import Logger from "@/utils/logger";
import AxiosProxy from "@/utils/axiosProxy";
import JseUtil from "@/utils/jseUtil";

const logger = new Logger();
globalThis.window.$log = logger;

const axiosProxy = new AxiosProxy();
globalThis.window.$axios = axiosProxy;

const jseUtil = new JseUtil();
globalThis.window.$jse = jseUtil;
